import scrollTo from "@degjs/scroll-to";
import MenuSpy from "menuspy";

const inPageNav = document.querySelector(".in-page-nav");

if (inPageNav) {
  const inPageNavItems = inPageNav.querySelectorAll("li a");
  const menuSpy = new MenuSpy(inPageNav, {
    threshold: 172,
  });

  window.addEventListener("scroll", function () {
    if (window.scrollY > inPageNav.offsetTop) {
      inPageNav.classList.add("fixed");
    }

    if (window.scrollY < inPageNav.offsetTop - 90 && window.innerWidth > 640) {
      inPageNav.classList.remove("fixed");
    }

    if (window.scrollY < inPageNav.offsetTop && window.innerWidth < 640) {
      inPageNav.classList.remove("fixed");
    }
  });

  [].forEach.call(inPageNavItems, (menuItem) => {
    menuItem.addEventListener("click", () => {
      let elementToShow = document.querySelector(
        `${menuItem.getAttribute("href")}`
      );

      if (elementToShow) {
        let elementPosition = elementToShow.offsetTop - 172;

        scrollTo({
          position: elementPosition,
          duration: 500,
          easing: "easeInOut",
        });
      }
    });
  });
}
